/* OPALE gallery presentation. Shopify's product-info remains the variant authority. */
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.op-gallery__track');
      if (!this.track) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelectorAll('[data-op-media]').forEach(button => button.addEventListener('click', () => this.setActiveMedia(button.dataset.opMedia), { signal }));
      this.querySelector('[data-op-gallery-prev]')?.addEventListener('click', () => this.move(-1), { signal });
      this.querySelector('[data-op-gallery-next]')?.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const slides = this.slides;
        if (event.key === 'Home') this.setActiveMedia(slides[0]?.dataset.mediaId);
        else if (event.key === 'End') this.setActiveMedia(slides.at(-1)?.dataset.mediaId);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting && entry.intersectionRatio > 0.6) this.announce(entry.target); });
      }, { root: this.track, threshold: 0.65 });
      this.slides.forEach(slide => this.observer.observe(slide));
      this.setActiveMedia(this.querySelector('.is-active')?.dataset.mediaId, false, true);
    }
    get slides() { return Array.from(this.track.querySelectorAll('.op-gallery__slide[data-media-id]')); }
    move(direction) {
      const slides = this.slides;
      const current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      this.setActiveMedia(slides[(current + direction + slides.length) % slides.length]?.dataset.mediaId);
    }
    setActiveMedia(mediaId, prepend = false, instant = false) {
      const slide = this.slides.find(item => item.dataset.mediaId === mediaId);
      if (!slide) return;
      this.announce(slide);
      const stacked = this.closest('[data-gallery-layout]')?.dataset.galleryLayout === 'stacked' && matchMedia('(min-width: 901px)').matches;
      const behavior = instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (stacked && !instant) slide.scrollIntoView({ block: 'nearest', behavior });
      else this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior });
      window.pauseAllMedia?.();
    }
    announce(slide) {
      this.slides.forEach(item => item.classList.toggle('is-active', item === slide));
      this.querySelectorAll('[data-op-media]').forEach(button => {
        if (button.dataset.opMedia === slide.dataset.mediaId) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      const status = this.querySelector('.op-gallery__status');
      if (status) status.textContent = `Image ${slide.dataset.position} of ${this.slides.length}`;
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
